import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { forMatLabel } from './lib/format-label';

const InitSelectedOptionByQuery = props => {
  const { options } = props;

  const searchParams = useSearchParams();
  const { setValue } = useFormContext();

  useEffect(() => {
    const querySize = searchParams.get('size');

    if (querySize) {
      const defaultValue = options
        .find(x => x.default_label === 'Size')
        ?.values?.find(x => {
          return x?.default_label?.toLowerCase().replace(/\s/g, '') === querySize.toLowerCase().replace(/\s/g, '');
        });

      if (!defaultValue) return;

      setValue(forMatLabel('Size'), {
        value_index: defaultValue?.value_index?.toString(),
        label: defaultValue?.label,
        price: defaultValue?.price,
        option_id: defaultValue?.option_id?.toString(),
      });
    }
  }, [options, searchParams, setValue]);

  return null;
};

export default InitSelectedOptionByQuery;
